
import OtpMobileForm from "./OtpMobileForm";
import OtpEmailForm from "./OtpEmailForm";
import CartServices from "../../Services/CartServices";

const GetContactInfoForm = ({hasSMSOption, activeTab, contactInfo, setContactInfo, countryCode, setCountryCode }) => {

    return (
        <>
            {hasSMSOption && CartServices.isMobileTab(activeTab) && (
                <OtpMobileForm
                    contactInfo={contactInfo}
                    setContactInfo={setContactInfo}
                    countryCode={countryCode}
                    setCountryCode={setCountryCode} />

            )}
            {CartServices.isEmailTab(activeTab) && (
                <OtpEmailForm
                    contactInfo={contactInfo}
                    setContactInfo={setContactInfo}
                />
            )}
            <small className="text-muted d-block">
                We'll send you a verification code on this{" "}
                {CartServices.isMobileTab(activeTab) ? "number" : "email"}
            </small>
        </>
    );
};

export default GetContactInfoForm;
